import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { PRODUCT_PAGE, FULFILLED } from '../../constants/constants'
import Heading from '../Heading/Heading'
import * as Styled from './styles'
import { useAppSelector } from '../../hooks'

interface Props {
  insideSummaryPanel?: boolean
}

const PriceSummary: React.FC<Props> = ({ insideSummaryPanel }) => {
  const { summary } = useAppSelector((state) => state.bundle)
  const { applicationMode, content } = useAppSelector((state) => state.init)
  const { requestStatus_fetchPrices_aggregated } = useAppSelector((state) => state.requests.requestStatus)

  const bundleHasAnyDiscount = summary && summary.Price !== summary.OrdinaryPrice ? true : false

  if (applicationMode === PRODUCT_PAGE) {
    return (
      <div id="price-block" className="price-block buy-wrapper no-page-break">
        {requestStatus_fetchPrices_aggregated === FULFILLED ? (
          <div className="row">
            <div className="col-xs-12 text-right">
              <div className="p-product-price">
                <span id="product-price" className="p-price">
                  {summary?.FormatedPrice}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <Skeleton width="190px" height="48px" style={{ marginLeft: 'calc(100% - 190px)' }} />
        )}
      </div>
    )
  }

  return (
    <Styled.PriceSummary
      bundleHasAnyDiscount={bundleHasAnyDiscount ?? undefined}
      $insideSummaryPanel={insideSummaryPanel}
    >
      <Heading level={2}>
        {requestStatus_fetchPrices_aggregated === FULFILLED ? (
          content?.priceSummary?.title
        ) : (
          <Skeleton width="70%" height="30px" />
        )}
      </Heading>
      <ul>
        {requestStatus_fetchPrices_aggregated === FULFILLED ? (
          <>
            {bundleHasAnyDiscount && (
              <li className="ordinary-price">
                <span>{content?.priceSummary?.ordinaryPrice}</span>
                <span>{summary?.FormatedOrdinaryPrice}</span>
              </li>
            )}
            {(summary?.ProductDiscount ?? 0) > 0 && (
              <li>
                <span>{content?.priceSummary?.save}</span>
                <span>- {summary?.FormatedProductDiscount}</span>
              </li>
            )}
            {(!import.meta.env.VITE_HIDE_DISCOUNTS || import.meta.env.VITE_HIDE_DISCOUNTS === 'false') &&
              summary?.Discounts.map(({ PromotionName, Discount, FormattedDiscount }: any) => (
                <li key={`${PromotionName}--${FormattedDiscount}`}>
                  <span>{PromotionName.trim()}</span>
                  {/* (Do not render "0 kr" for campaign type "På köpet") */}
                  {Discount !== 0.0 && <span>- {FormattedDiscount}</span>}
                </li>
              ))}

            <li className="price">
              <span>{content?.priceSummary?.total}</span>
              <span>{summary?.FormatedPrice}</span>
            </li>
          </>
        ) : (
          <Skeleton count={2} height="30px" />
        )}
      </ul>
    </Styled.PriceSummary>
  )
}

export default PriceSummary
